<style lang="scss" scoped>
.tribe-box-category {
    .ar {
        position: relative;

        img {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            border-radius: 4px;
            width: 100%;
            height: 100%;
            object-fit: cover;
            font-family: "object-fit: cover;";
        }
    }

    .title {
        font-size: 1.5rem;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 2.125rem;
    }
}
</style>

<template>
    <div class="tribe-box-category">
        <div class="ar mb-16" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
            <img :src="category.acf.meta.image.sizes.medium_large" :alt="category.name">
        </div>
        <p class="title mb-8" v-html="category.name"></p>
        <div class="text-dark font-weight-light small mb-24" v-html="category.acf.meta.content"></div>
        <a class="btn btn-accent" :href="route('nl.tribebox', category.slug)">Kies jouw Tribe Box <span class="arrow-right" v-html="svg('arrow-right')" /></a>
    </div>
</template>

<script>
export default {
    props: {
        category: {
            type: Object,
            required: true
        },

        ratio: {
            type: [String, Boolean],
            default: '588:240',
            required: false
        }
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },
    }
}
</script>